import {
  ChangeDetectorRef,
  Component,
  inject,
  SimpleChanges,
} from '@angular/core';
import { ActivatedRoute, Event, NavigationEnd, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { GoogleTagAnalyticsService } from '@/app/services/google-tag';
import { RouteValidatorService } from '@/app/services/route-validator.service';
import { CommonModule } from '@angular/common';
import { NzSkeletonComponent } from 'ng-zorro-antd/skeleton';
import { environment } from '../../../environments/environment';
import { BreadcrumbsComponent } from '../../components/shared/breadcrumbs/breadcrumbs.component';
import { TabBarComponent } from '../../components/shared/tab-bar/tab-bar.component';
import { CompetitionModel } from '../../models/favorite/competition.model';
import { LocalStorageService } from '../../services/localstorage.service';
import { ScoresSportsService } from '../../services/scores-sports.service';
import { SportsService } from '../../services/sport.service';
import { StandingsFootballComponent } from '../match-details/components/standings-football/standings-football.component';
import { StandingsSportsComponent } from '../match-details/components/standings-sports/standings-sports.component';
import { ParamsModel } from '../match-details/models/params.model';
import { EGoogleTagAnalyticsKeys } from '../sports/football/enums';
import { LastesMatchesComponent } from './components/lastes-matches/lastes-matches.component';
import { NextMatchesComponent } from './components/next-matches/next-matches.component';
import { TodayMatchesComponent } from './components/today-matches/today-matches.component';
import { ROUTE_FOOTBALL, ROUTE_FOOTBALL_EN } from '@/app/routes';
import { TranslationService } from '@/app/services/translation.service';
import { ELanguage } from '@/app/utils';

@Component({
  selector: 'app-competition-details',
  standalone: true,
  imports: [
    BreadcrumbsComponent,
    NzSkeletonComponent,
    CommonModule,
    TabBarComponent,
    StandingsFootballComponent,
    StandingsSportsComponent,
    TranslateModule,
    LastesMatchesComponent,
    NextMatchesComponent,
    TodayMatchesComponent,
  ],
  templateUrl: './competition-details.component.html',
  styleUrl: './competition-details.component.scss',
})
export class CompetitionDetailsComponent {
  private routeValidatorService = inject(RouteValidatorService);
  private translationService = inject(TranslationService);
  private googleTagAnalyticsService = inject(GoogleTagAnalyticsService);

  loader = true;
  loaderMatches = true;

  myCompetitionsList = this.lsService.getFavoriteFromLocal('COMPETITION');

  urlSVG = environment.urlIcon;
  urlIMG = environment.urlIMG;
  urlMatch: boolean = false;

  competitionInfo: CompetitionModel = {} as CompetitionModel;

  selectedIndex: number = 0;
  optionsMenuSelected: number = 0;

  constructor(
    private lsService: LocalStorageService,
    private ref: ChangeDetectorRef,
    private readonly router: Router,
    private readonly _activateRoute: ActivatedRoute,
    public scoresServices: ScoresSportsService,
    public readonly sportsServices: SportsService
  ) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.urlMatch = event.url.includes('/partido/');
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this._activateRoute.params.subscribe((params: any) => {
      if (params) this.getCompetitionInfo(params);
      else
        this.router.navigate(['/scores/Futbol'], {
          replaceUrl: true,
          queryParamsHandling: 'preserve',
        });
    });
  }

  ngOnInit(): void {
    if (this.sportsServices.getSelectedSport() == 'Futbol') {
      this.router.navigate(['/']);
      return;
    }

    this.lsService.changeCompetitionsFavorites.subscribe((updatedList) => {
      this.myCompetitionsList = updatedList;
      this.competitionInfo.favorite =
        this.myCompetitionsList.find(
          (elem: any) =>
            elem.idCompetition === this.competitionInfo.idCompetition
        ) != null;
    });

    this._activateRoute.params.subscribe((params: any) => {
      if (params) {
        this.getCompetitionInfo(params);
        this.router.navigate([this.routeValidatorService.currentUrl()], {
          replaceUrl: true,
          queryParamsHandling: 'preserve',
        });
      } else {
        if (this.translationService.getCurrentLanguage() === ELanguage.EN) {
          this.router.navigate([ROUTE_FOOTBALL_EN], {
            replaceUrl: true,
            queryParamsHandling: 'preserve',
          });
        } else {
          this.router.navigate([ROUTE_FOOTBALL], {
            replaceUrl: true,
            queryParamsHandling: 'preserve',
          });
        }
      }
    });
  }

  private getCompetitionInfo(params: ParamsModel) {
    this.competitionInfo = {} as CompetitionModel;
    this.scoresServices.dashboardScores = [];
    this.loader = true;
    this.loaderMatches = true;
    this.scoresServices.getCompetitionById(params.idCompetition).subscribe(
      (response: any) => {
        if (response.status) {
          // google analytics
          this.googleTagAnalyticsService.event(
            EGoogleTagAnalyticsKeys.VIEW_COMPETITION,
            {
              ...response.competition,
            }
          );

          this.competitionInfo = response.competition;
          // TODO: delete favorito
          // const favoritesCompetition: any =
          //   this.lsService.getFavoriteFromLocal('COMPETITION');
          // this.competitionInfo.favorite =
          //   favoritesCompetition.length === 0
          //     ? false
          //     : favoritesCompetition.find(
          //         (elem: any) =>
          //           elem.idCompetition === this.competitionInfo.idCompetition
          //       ) != null;
          this.loader = false;
        } else this.loader = false;
      },
      () => {
        this.loader = false;
      }
    );
  }

  // TODO: delete favorito
  // favoriteCompetition() {
  //   const data: any = {
  //     idCompetition: this.competitionInfo.idCompetition,
  //     nameEs: this.competitionInfo.nameEs,
  //     nameEn: this.competitionInfo.nameEn,
  //     competitionLogo: this.competitionInfo.logo,
  //     country: this.competitionInfo.country,
  //   };
  //   if (this.lsService.setFavoritesCompetition(data)) {
  //     this.competitionInfo.favorite = !this.competitionInfo.favorite;
  //     this.ref.markForCheck();
  //   }
  // }

  menuSelected(event: number) {
    this.optionsMenuSelected = event;
  }
}
